<template>
  <div style="width: 80px; text-align: center">
    <p :class="[levelClass(3), 'mt-0 mb-0 pt-0 pb-0']">Pro</p>
    <p :class="[levelClass(2), 'mt-0 mb-0 pt-0 pb-0']">Med</p>
    <p :class="[levelClass(1), 'mt-0 mb-0 pt-0 pb-0 ']">Jr</p>
  </div>
</template>

<script>
export default {
  name: "LevelIndicator",
  props: {
    level: {
      type: Number,
      required: true,
      validator: (v) => [1, 2, 3].includes(v),
    },
  },
  methods: {
    levelClass(targetLevel) {
      const activeColorByLevel = {
        1: "grey--text text--darken-2",
        2: "blue--text ",
        3: "green--text text--darken-2",
      };

      return this.level === targetLevel
        ? `text-h4 ${activeColorByLevel[targetLevel]}  font-weight-medium`
        : "text-h7 grey--text text-bold text--lighten-1";
    },
  },
};
</script>

<style scoped>
.level-control {
  display: flex;
  align-items: center;
}

/* Base segment */
.segment {
  width: 28px;
  height: 20px;
  background-color: #e0e0e0;
}

/* Rounded ends */
.segment:first-child {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.segment:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

/* Small spacing between segments (optional) */
.segment + .segment {
  margin-left: 4px;
}

/* Colors */
.orange {
  background-color: #ff3b30;
}

.blue {
  background-color: #007aff;
}

.green {
  background-color: #34c759;
}

.grey {
  background-color: #eeecec;
}
</style>
